"use client";
import FooterIconsBox from "@/components/footer/footer-icons-box";
import FooterContent from "@/components/footer/footer-content";
import FooterCopyright from "@/components/footer/footer-copyright";
import { usePathname } from "next/navigation";

export default function Footer() {
  let pathname = usePathname();
  
  // 如果 pathname 以 /login 开头，不显示 header
  if (pathname?.startsWith('/login')||pathname?.startsWith('/register')) {
    return null;
  }
  
    return <footer className="bg-white">
        <div className="container py-8">
            <FooterIconsBox/>
            <FooterContent/>
            <FooterCopyright/>
        </div>
    </footer>;
}
